import React from 'react';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';

function WorkersForm(props) {

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
          props.getWorkers();
        };
    };

    return (
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: 'column'}}>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: props.isMobile ? 'column' : 'row', mb: '10px'}}>
                <label>Filter By</label>
            </Box>
            <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} sx = {{display: 'flex', flexDirection: props.isMobile ? 'column' : 'row', mb: '10px'}}>
                <TextField 
                    name = 'name'
                    label = 'Name'
                    onChange = {(e) => props.setName(e.target.value)}
                    value = {props.name}
                    onKeyDown = {handleKeyDown}
                    sx = {{ width: '40%', mr: '0.6%' }}
                />
                 <FormControl sx = {{ width: '20%', mr: '0.6%' }}>
                <AutoComplete
                    value = {props.status_options.find(option => option.value === props.status) || null}
                    onChange = {(event, newValue) => {
                        props.setStatus(newValue ? newValue.value : null);
                    }}
                    onKeyDown = {handleKeyDown}
                    id = "status"
                    options = {props.status_options}
                    getOptionLabel = {(option) => {
                        return `${option.name}`;
                    }}
                    renderOption = {(props, option) => {
                        return (
                            <li {...props}>
                                {`${option.name}`}
                            </li>
                        );
                    }}
                    renderInput = {(params) => (
                        <TextField {...params} label = "Status" />
                    )}
                />
            </FormControl>
                <Tooltip title = {"Clear filter."}  placement = 'right' >
                    <span>
                        <IconButton 
                            aria-label = "clearFilter" 
                            onClick = {props.clearWorkerSearch} 
                            sx = {{ mt: '5px', color: '#96605a' }}
                        >
                            <FilterAltOffIcon />
                        </IconButton>
                    </span>
                </Tooltip>
                {/* <Tooltip title = {"Apply filter."}  placement = 'right' >
                    <span>
                        <IconButton 
                            aria-label = "filter" 
                            onClick = {props.getWorkers} 
                            sx = {{ mt: '5px', color: '#7c8978' }}
                        >
                            <FilterAltIcon />
                        </IconButton>
                    </span>
                </Tooltip> */}
                { props.workers.length > 0 ? 
                    <Tooltip title = {"Export Workers."}  placement = 'right' >
                        <span>
                            <IconButton 
                                aria-label = "export" 
                                onClick = {props.exportWorkers} 
                                sx = {{ mt: '5px', color: '#7d5265' }}
                            >
                                <FileDownloadIcon />
                            </IconButton>
                        </span>
                    </Tooltip>
                : null }
                 <Tooltip title = {"Add Workers."}  placement = 'right' >
                    <span>
                        <IconButton 
                            aria-label = "add_worker" 
                            onClick = {() => props.setOpenInsertWorkerPopup(true)} 
                            sx = {{ mt: '5px', color: '#7c8978' }}
                        >
                            <PersonAddAlt1Icon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>
        </Box>
    );
};

export default WorkersForm;